
































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import {
  ContentPriceSubjectTypeEnum,
  ContentPurchase,
  InputContentPurchaseSearch,
} from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { FundraisingGoalRewardPurchaseDetails } from "@scrile/api-provider/dist/api/FundraisingGoalsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import FundraisingGoalRewardCard from "@/components/FundraisingGoal/FundraisingGoalRewardCard";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageRewards",
  components: {
    EmptyContent,
    FundraisingGoalRewardCard,
    InfiniteScroll,
    BaseMenu,
    BaseIcon,
    BaseSpinner,
    PageTitle,
    BasePage,
  },
  setup() {
    const { authUser } = useAuthUser();

    const loading = ref(false);
    const sort = ref("TIME,DESC");

    const sortItems: BaseMenuItem[] = [
      {
        text: $t("Newest"),
        name: "newest",
        value: "TIME,DESC",
      },
      {
        text: $t("Oldest"),
        name: "oldest",
        value: "TIME,ASC",
      },
    ];

    const fragment =
      providers.ContentPriceProvider.getFragment("ContentPurchaseDetails") +
      `
      content {
        ... on FundraisingGoalRewardPurchaseDetails {
          reward {
            ${providers.FundraisingGoalsProvider.getFragment("FundraisingGoalReward")}
            goal {
              ${providers.FundraisingGoalsProvider.getFragment("FundraisingGoal")}
            }
          }
        }
      }
    `;

    const activeSortTitle = computed(() => sortItems.find(item => item.value === sort.value)?.text);

    const { enableScroll, items, getFirstPage, getNextPage } = usePager<
      ContentPurchase<FundraisingGoalRewardPurchaseDetails>,
      InputContentPurchaseSearch
    >(page => {
      return providers.ContentPriceProvider.searchPurchases(
        {
          data: {
            userId: authUser.value?.id,
            subjectType: ContentPriceSubjectTypeEnum.FUNDRAISING_GOAL_REWARD,
            page,
            sort: sort.value,
          },
        },
        fragment
      );
    });

    const rewards = computed(() => items.value.map(item => item.content.reward));

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPage();
      } finally {
        loading.value = false;
      }
    };

    getData();

    watch(sort, getData);

    return { loading, enableScroll, rewards, sortItems, sort, activeSortTitle, getNextPage };
  },
});
